import { createContext, useContext } from 'react';

interface HoneyMoonContextType {
  data: ViagemHoneyMoonPageDataType;
}

const HoneyMoonContext = createContext<HoneyMoonContextType>({} as HoneyMoonContextType);

export const useHoneyMoonContext = () => {
  return useContext(HoneyMoonContext);
};

export default HoneyMoonContext;
